export default "__VITE_ASSET__C3SXg5WX__"